import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { IPI3TaxTable } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class IPI3Repository extends RepositoryBase<IPI3TaxTable> {
  protected readonly KEY_PATH = 'ipi3';
}
